// تشغيل صوت مُرمَّز base64 عبر WebAudio — بديل عندما يرفض iOS Safari تشغيل Audio.play().
export const playBase64Mp3 = async (base64) => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx || !base64) return false;
  try {
    const ctx = new Ctx();
    if (ctx.state === "suspended") await ctx.resume();
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const buffer = await ctx.decodeAudioData(bytes.buffer);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
    return true;
  } catch {
    return false;
  }
};

// ملاحظة حرجة: نوع الوسيط يجب أن يطابق صيغة الخادم (wav) — و"audio/mp3" مرفوض في iOS Safari.
export const AUDIO_MIME = "audio/wav";

export const audioFromBase64 = (base64, mime) => {
  const audio = new Audio(`data:${mime || AUDIO_MIME};base64,${base64}`);
  audio.preload = "auto";
  audio.volume = 1;
  return audio;
};
